export enum QUERY_KEYS {
  getInvoices = "INVOICES_GET",
  getDiscounts = "DISCOUNTS_GET",
  getWalletTransactions = "WALLET_TRANSACTIONS_GET",
  walletBalance = "WALLET_BALANCE_GET",
}
